<nav mat-tab-nav-bar [backgroundColor]="backgroundColor" [tabPanel]="tabPanel">
  <a appAccessControl accessRoles="{{link.actions}}" mat-tab-link *ngFor="let link of links" [routerLink]='[link.route]'
    [routerLinkActive]="'active'">
    {{link.title}}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>